import ConfirmPayment from "../components/ConfirmPayment";

export default function PaymentConfirmation() {
    return(
        <>
            <ConfirmPayment />
        </>
    )
}